<button mat-raised-button [matMenuTriggerFor]="reportOptions" class="gray-button" [disabled]="config == null">Options</button>
<mat-menu #reportOptions="matMenu">
  <button mat-menu-item *ngFor="let item of config" (click)="clickEvent.emit(item.trim())">{{ item }}</button>
</mat-menu>
